import moment from 'moment'
import { MomentInput } from 'moment'

function determineIsDateValid(date?: MomentInput | null): boolean {
  return Boolean(date) ? moment(date).isValid() : false
}

export default determineIsDateValid
